import script from "./CommentsDrawClub.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsDrawClub.vue?vue&type=script&setup=true&lang=js"

import "./CommentsDrawClub.vue?vue&type=style&index=0&id=ba228324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba228324"]])

export default __exports__